/**
 * MobileWrapper Component
 * Centralized wrapper for mobile-responsive layouts with standardized padding and spacing
 * Prevents element squishing and ensures content fits well within screen boundaries
 */

import React from "react";
import styled from "styled-components";
import useDeviceType from "../../features/leads/hooks/useDeviceType";

const WrapperContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  
  /* Responsive padding */
  padding: ${(props) => {
    if (props.$isMobile) return "8px 12px";
    if (props.$isTablet) return "12px 16px";
    return "16px 24px";
  }};

  /* Ensure content expands properly */
  box-sizing: border-box;
  
  /* Prevent element squishing in flex/grid layouts */
  min-width: 0;
  
  /* Full width on mobile, constrained on desktop */
  ${(props) =>
    !props.$isMobile &&
    `
    max-width: 1400px;
    margin: 0 auto;
  `}

  /* Optional fullWidth prop removes side padding */
  ${(props) =>
    props.$fullWidth &&
    `
    padding-left: 0;
    padding-right: 0;
  `}
`;

/**
 * MobileWrapper Component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to wrap
 * @param {boolean} [props.fullWidth] - Remove side padding for full-width content
 * @param {string} [props.className] - Additional CSS classes
 */
const MobileWrapper = ({ children, fullWidth = false, className, ...props }) => {
  const { isMobile, isTablet } = useDeviceType();

  return (
    <WrapperContainer
      $isMobile={isMobile}
      $isTablet={isTablet}
      $fullWidth={fullWidth}
      className={className}
      {...props}
    >
      {children}
    </WrapperContainer>
  );
};

export default MobileWrapper;

